import React, { useCallback, useEffect, useState } from "react";
import { Descriptions, Skeleton, Image, Empty, Col, Row, Modal } from "antd";
import { baseRescueArr, ItemCodeMap, PriceItemData, PricingDataType, ViewItem } from "../../../../constants/pricing";
import { OSS } from "../../../../requestor/oss";
import Requestor from "../../../../requestor";
import ModelContent from "../../../../components/modelContent";
import * as PriceItemsRenderer from "./itemRender";
import NavigationRuote from "../../../../components/navigation";

const PriceDetail: React.FC<{ sid: string }> = ({ sid }) => {

  const [items, updateItems] = React.useState<PriceItemData>();
  const [priceData, setPriceData] = useState<PricingDataType | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [navigateItem, setNavigateItem] = useState<ViewItem | null>(null);

  useEffect(() => {
    if (!sid) return;
    getItemsDetail();
    getPriceDetails();
  }, [sid]);

  // 核价详情
  const getPriceDetails = useCallback(async () => {
    const res = await Requestor.getPricingDetails<PricingDataType>(sid);
    if (res.error !== "") {
      setLoading(false);
      throw new Error(res.error);
    }
    setPriceData(res.result);
    setLoading(false);
  }, [sid]);

  // 服务项详情
  const getItemsDetail = useCallback(async () => {
    const res = await Requestor.getPriceItemsDetail<ViewItem[]>(sid);

    if (res.error !== "") {
      throw new Error(res.error);
    }
    if (!res.result.length) return;
    const _items = res.result.reduce((pre: any, el: ViewItem) => {
      const key = ItemCodeMap[el.item.itemCode];
      if (key === "vt") {
        pre[key] = pre[key] ? pre[key].concat([el]) : [el];
      } else {
        pre[key] = { ...el };
      }
      return pre;
    }, {});

    updateItems(_items);
  }, [sid]);

  return (
    <div>
      <ModelContent title="报案信息" >
        <Skeleton active loading={priceData === null}>
          <Descriptions column={2}>
            <Descriptions.Item label="报案号">
              {priceData && priceData.outNo}
            </Descriptions.Item>
            <Descriptions.Item label="车型大小">
              {["小型车", "中型车", "中大型车"][priceData ? priceData.size : 0]}
            </Descriptions.Item>
            <Descriptions.Item label="救援模式">
              {priceData?.mode === 1 ? '非事故救援' : '事故救援'}
            </Descriptions.Item>
            <Descriptions.Item label="施救类型">
              {priceData?.type === 1 ? "商用车" : "乘用车"}
            </Descriptions.Item>
            <Descriptions.Item label="查勘员">
              {priceData?.surveyorName}
            </Descriptions.Item>
            <Descriptions.Item label="当地报价">
              ￥{priceData ? priceData?.localFee / 100 : "--"}
            </Descriptions.Item>
            <Descriptions.Item label="拖车侠报价">
              ￥{priceData ? priceData?.totalFee / 100 : "--"}
            </Descriptions.Item>
          </Descriptions>
          <div>
            <span style={{ marginBottom: "8px", color: "rgba(0, 0, 0, 0.45)" }}>报案图片:</span>
            <Row style={{ marginTop: "8px" }}>
              <Image.PreviewGroup>
                {priceData?.pictures?.map(_oid => {
                  return (
                    <Col style={{ margin: "0 8px 8px 0"}} key={_oid}>
                      <Image
                        width={102}
                        height={102}
                        src={OSS.redirectToImage(_oid)}
                        preview={{
                          src: OSS.redirectToImage(_oid),
                        }}
                      />
                    </Col>
                  );
                })}
              </Image.PreviewGroup>
            </Row>
          </div>
        </Skeleton>
      </ModelContent>
      <ModelContent title="服务项目">
        <Skeleton active loading={loading}>
          {!items
            ? <Empty description="没有服务项" />
            : (
              <>
                <PriceItemsRenderer.VT items={items?.vt} onOpenNavigate={setNavigateItem}/>
                <PriceItemsRenderer.Crane item={items?.crane} onOpenNavigate={setNavigateItem}/>
                <PriceItemsRenderer.Crane1 item={items?.crane1} onOpenNavigate={setNavigateItem}/>
                <PriceItemsRenderer.SR item={items?.sr} />
                {baseRescueArr.map((el, index) => {
                  return (
                    <PriceItemsRenderer.BaseRescue
                      item={items![el.key]}
                      title={el.title}
                      key={`${el.key}-${index}`}
                    />
                  )
                })}
                <PriceItemsRenderer.Wheel item={items?.wheel} />
              </>
            )}

        </Skeleton>
      </ModelContent>
      <Modal 
        title="查看导航路径" 
        open={!!navigateItem} 
        onCancel={() => setNavigateItem(null)}
        footer={null}
      >
        {navigateItem && (
          <NavigationRuote 
            item={navigateItem}
          />
        )}
      </Modal>
    </div>
  );
};

export default PriceDetail;
